/* ═══════ Paintly cart drawer engine — ported from Paintly-CartDrawer-v16-Final proto ═══════
   State computed from #pcCartData (re-rendered by Liquid on every cart update).
   Re-initializes via MutationObserver whenever Shrine re-renders the drawer. */
(function () {
  'use strict';
  if (!document.getElementById('PaintlyCartPage') || window.paintlyCartPageReady) return;
  window.paintlyCartPageReady = true;
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="9" width="18" height="4" rx="1"/><path d="M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6M12 9v12M12 9c-2 0-4.5-.8-4.5-3A2 2 0 0 1 10 4c2 0 2 3 2 5zm0 0c2 0 4.5-.8 4.5-3A2 2 0 0 0 14 4c-2 0-2 3-2 5z"/></svg>';
  var CAL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 11h18"/></svg>';
  /* recipient rows are rendered as chips instead, so they come out of the raw property list */
  var GIFT_PROPS = ['recipient email', 'recipient name', 'send on', 'message'];
  var PK_MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function giftDate(v) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v || ''));
    if (!m) return '';
    var mi = parseInt(m[2], 10) - 1;
    if (mi < 0 || mi > 11) return '';
    return parseInt(m[3], 10) + ' ' + PK_MON[mi] + ' ' + m[1];
  }
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 7L9 18l-5-5"/></svg>';
  var PALETTE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3C7 3 3 7 3 12s4 9 9 9c1.3 0 2.2-.9 2.2-2.1 0-.6-.2-1-.6-1.4-.4-.4-.6-.9-.6-1.4a2 2 0 0 1 2-2H17a5 5 0 0 0 5-5c0-3.7-4.5-6.1-10-6.1z"/><circle cx="7.6" cy="10.6" r="1.15" fill="currentColor" stroke="none"/><circle cx="11.3" cy="7.2" r="1.15" fill="currentColor" stroke="none"/><circle cx="15.9" cy="8.4" r="1.15" fill="currentColor" stroke="none"/></svg>';
  var GEM = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M7 4h10l4 5-9 11L3 9z"/><path d="M3 9h18M12 20L8.5 9M12 20l3.5-11"/></svg>';
  var PEARL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="7.6" cy="9.4" r="3.9"/><circle cx="16.4" cy="9.4" r="3.9"/><circle cx="12" cy="16.6" r="3.9"/></svg>';
  var FXC = ['#C5FF89', '#A6E85F', '#CEA3D9', '#9A6BB0', '#DDD0E6', '#3B303E'];

  var CUR = { iso: 'USD', sym: '$' }; /* updated from the cart blob each render */
  function money(cents) {
    return CUR.sym + (cents / 100).toFixed(2);
  }
  function codeFromData(d) {
    /* the cart itself is the source of truth: any discount application of type
       'discount_code' on the cart or its lines means a code is on.
       Returns the whole application ({t,n,vt,v}) so the caller can tell a percentage
       code from a fixed-amount one — the code's own characters say nothing. */
    var found = null;
    function take(a) { if (a && a.t === 'discount_code' && !found) found = a; }
    (d.cart_apps || []).forEach(take);
    (d.items || []).forEach(function (x) { (x.apps || []).forEach(take); });
    return found;
  }
  var pageBusy = false, pageSyncTimer, pageUncertain = false;
  var drawerSyncPending = false, drawerSeen = '';
  function pageRoot() { return document.getElementById('PaintlyCartPage'); }
  function pageMessage(message, code) {
    var el = document.getElementById(code ? 'pcCodeError' : 'pcPageError');
    if (el) {
      el.textContent = message || '';
      if (pageUncertain) {
        var retry = document.createElement('a');
        retry.href = pageRoot().dataset.cartUrl;
        retry.textContent = pageRoot().dataset.reload;
        retry.style.cssText = 'display:block;text-decoration:underline;margin-top:8px;color:inherit';
        el.appendChild(retry);
      }
    }
  }
  function pageBusySet(busy) {
    pageBusy = busy;
    var root = pageRoot(); if (!root) return;
    root.setAttribute('aria-busy', busy ? 'true' : 'false');
    root.querySelectorAll('button,input,textarea').forEach(function(el) { el.disabled = busy || pageUncertain || (el.id === 'pcCheckout' && root.classList.contains('is-empty')); });
    var status = document.getElementById('pcPageStatus'); if (status) status.textContent = busy ? root.dataset.updating : '';
    if (!busy && drawerSyncPending) scheduleDrawerSync();
  }
  function cartSignature(id) {
    var el = document.getElementById(id);
    try {
      if (!el) return '';
      var page = id === 'pcCartData';
      var rows = Array.from(document.querySelectorAll(page ? '#PaintlyCartPage .pc-item' : '#CartDrawer .cart-drawer-item')).map(function(row) {
        var link = row.querySelector('.cart-item__name'), img = row.querySelector('img');
        var url = link ? new URL(link.getAttribute('href'), location.href) : null;
        return [row.dataset.quantity, row.dataset.key || (url && url.searchParams.get('edit')), url && url.pathname, url && url.searchParams.get('variant'), img && img.getAttribute('src')];
      });
      return JSON.stringify([JSON.parse(el.textContent), rows]);
    } catch (err) { return ''; }
  }
  function scheduleDrawerSync() {
    clearTimeout(pageSyncTimer);
    pageSyncTimer = setTimeout(function() {
      if (pageBusy || !drawerSyncPending) return;
      drawerSyncPending = false;
      pageBusySet(true);
      refreshDrawer().catch(function() {
        pageUncertain = true;
        pageMessage(pageRoot().dataset.connectionError, false);
      }).finally(function() { pageBusySet(false); });
    }, 200);
  }
  function sectionNames() { return [pageRoot().dataset.sectionId, 'cart-drawer', 'cart-icon-bubble']; }
  function applySections(sections) {
    var root = pageRoot(); if (!root) return false;
    var html = sections && sections[root.dataset.sectionId];
    if (!html) throw new Error(root.dataset.connectionError);
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.getElementById('PaintlyCartPage');
    if (!fresh) throw new Error(root.dataset.connectionError);
    var active = document.activeElement;
    var focusKey = active && active.closest('.pc-item');
    var focusStep = active && active.getAttribute('data-quantity-step');
    var focusInput = active && active.name === 'updates[]';
    if (pcMo) pcMo.disconnect();
    root.replaceWith(fresh);
    pageUncertain = false;
    if (sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var next = doc.getElementById('CartDrawer'), old = document.getElementById('CartDrawer');
      if (next && old) old.innerHTML = next.innerHTML;
      var nextHost = doc.querySelector('cart-drawer'), host = document.querySelector('cart-drawer');
      if (host && nextHost) host.classList.toggle('is-empty',nextHost.classList.contains('is-empty'));
      drawerSeen = cartSignature('pkCartData');
    }
    if (sections['cart-icon-bubble']) {
      var iconDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html');
      var icon = document.getElementById('cart-icon-bubble');
      if (icon) icon.innerHTML = (iconDoc.querySelector('.shopify-section') || iconDoc.body).innerHTML;
    }
    render();
    if (focusKey) {
      var target = Array.from(fresh.querySelectorAll('.pc-item')).find(function(el) { return el.dataset.key === focusKey.dataset.key; });
      var control = target && (focusInput ? target.querySelector('input') : Array.from(target.querySelectorAll('[data-quantity-step]')).find(function(el){return el.dataset.quantityStep === focusStep;}));
      if (control) control.focus({preventScroll:true});
    }
    return true;
  }
  function refreshDrawer() {
    var root=pageRoot();
    return fetch(root.dataset.cartUrl+'?sections='+sectionNames().map(encodeURIComponent).join(','),{credentials:'same-origin'})
      .then(function(r){if(!r.ok) throw new Error(root.dataset.connectionError);return r.json();})
      .then(applySections);
  }
  function changeCart(endpoint,body,code) {
    if(pageBusy || pageUncertain) return Promise.resolve(null);
    var root=pageRoot();pageMessage('',code);pageBusySet(true);
    body.sections=sectionNames();body.sections_url=root.dataset.cartUrl;
    return fetch(root.dataset.root+'cart/'+endpoint+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify(body)})
      .then(function(r){return r.json().then(function(data){return {ok:r.ok,data:data};});})
      .then(function(result){
        if(!result.ok || result.data.status){
          var msg=result.data.description || result.data.message || root.dataset.error;
          throw new Error(msg);
        }
        if(result.data.sections) applySections(result.data.sections);
        else return refreshDrawer().then(function(){return result.data;});
        return result.data;
      }).catch(function(err){
        var message = err.message === 'Failed to fetch' ? root.dataset.connectionError : (err.message || root.dataset.error);
        return refreshDrawer().then(function(){pageMessage(message,code);return null;}).catch(function(){
          pageUncertain = true;
          pageMessage(root.dataset.connectionError,code);
          return null;
        });
      })
      .finally(function(){pageBusySet(false);});
  }
  function checkoutCart() {
    if (pageBusy || pageUncertain) return;
    var before = cartSignature('pcCartData');
    pageBusySet(true);
    refreshDrawer().then(function() {
      if (before !== cartSignature('pcCartData') || drawerSyncPending || pageRoot().classList.contains('is-empty')) {
        pageMessage(pageRoot().dataset.changed, false);
        return;
      }
      var form = document.createElement('form');
      form.method = 'post'; form.action = pageRoot().dataset.cartUrl;
      var checkout = document.createElement('input');
      checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = 'Checkout';
      form.appendChild(checkout); document.body.appendChild(form);
      HTMLFormElement.prototype.submit.call(form);
    }).catch(function() {
      pageUncertain = true;
      pageMessage(pageRoot().dataset.connectionError, false);
    }).finally(function() { pageBusySet(false); });
  }

  function readData() {
    var el = document.getElementById('pcCartData');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function computeState(d) {
    /* IMPORTANT: discounts apply IN the cart on this store, so d.total is already the real
       amount payable and d.total_discount already carries the saving. The two kinds land in
       different places though: the B2G1 automatic deal is a LINE-level allocation, a whole-order
       code is a CART-level one. "original" below is the pre-discount goods total and must be
       correct for both; all display math starts from it. */
    var units = [];
    d.items.forEach(function (x, li) {
      /* gift cards are outside the Buy-2-Get-1 discount scope in Shopify — they must
         not count as "kits" toward the every-3rd-kit meter or the free-unit estimate */
      if (x.gift) return;
      for (var k = 0; k < x.qty; k++) units.push({ li: li, p: x.price });
    });
    var n = units.length;
    /* Pre-discount goods total. d.goods is summed in Liquid from item.original_line_price,
       so it is right for BOTH kinds of discount. Do NOT go back to subtotal+total_discount:
       cart.items_subtotal_price is net of LINE-level discounts only, so a whole-order code
       (which Shopify applies at cart level) is still inside it and adding the discount back
       double-counts it — that was the phantom "was" figure the drawer used to show.
       The item sum is a fallback for the first render after a JS-before-Liquid deploy. */
    var original = d.goods;
    if (typeof original !== 'number' || original <= 0) {
      original = 0;
      d.items.forEach(function (x) { original += x.price * x.qty; });
    }
    var codeApp = codeFromData(d);
    var code = codeApp ? { label: String(codeApp.n).toUpperCase(), vt: codeApp.vt || '', pct: 0, txt: '' } : null;
    var freeCount = 0, save = 0, codeOff = 0, freeBy = {}, realDeal = false, paid;
    if (code) {
      /* code is ON the cart: every number is Shopify's real math */
      codeOff = d.total_discount;
      paid = d.total;
      /* the percentage is derived from the money, never scraped out of the code's characters */
      code.pct = original > 0 ? Math.round(codeOff / original * 100) : 0;
      if (codeOff <= 0) code.txt = '';                                   /* shipping-only, or nothing to discount */
      else if (code.vt === 'fixed_amount') code.txt = money(codeOff) + ' off';
      else code.txt = code.pct + '% off';
    } else if (d.total_discount > 0) {
      /* trust Shopify's real automatic discount */
      realDeal = true;
      save = d.total_discount;
      freeCount = Math.floor(n / 3);
      paid = d.total;
      d.items.forEach(function (x, li) {
        if (x.line_discount > 0 && x.price > 0) freeBy[li] = Math.min(x.qty, Math.round(x.line_discount / x.price));
      });
    } else {
      freeCount = 0; save = 0; paid = d.total;
    }
    var fill = n === 0 ? 0 : (n % 3 === 0 ? 3 : n % 3);
    var left = n === 0 ? 3 : (n % 3 === 0 ? 3 : 3 - (n % 3));
    return {
      n: n, sub: original, freeCount: freeCount, save: save, codeOff: codeOff, freeBy: freeBy,
      code: code, realDeal: realDeal, tot: paid, fill: fill, left: left, lap: n > 0 && n % 3 === 0,
      shipPct: Math.min(100, paid / d.ship_free * 100),
      shipLeft: Math.max(0, d.ship_free - paid),
      shipDone: paid >= d.ship_free && n > 0
    };
  }

  /* ── fx ── */
  var parts = [], fxRun = false;
  function fxCanvas() {
    var inner = document.querySelector('.paintly-cart-page .pc-shell');
    if (!inner) return null;
    var cv = inner.querySelector('#pcFx');
    if (!cv) {
      cv = document.createElement('canvas'); cv.id = 'pcFx';
      inner.appendChild(cv);
      var fo = document.createElement('div'); fo.className = 'pc-flashov'; inner.appendChild(fo);
      var bb = document.createElement('div'); bb.className = 'pc-bigban'; inner.appendChild(bb);
      if (getComputedStyle(inner).position === 'static') inner.style.position = 'relative';
    }
    cv.width = inner.clientWidth; cv.height = inner.clientHeight;
    return cv;
  }
  function blast(x, y, nn) {
    var cv = fxCanvas(); if (!cv) return;
    var n = nn || 110;
    for (var i = 0; i < n; i++) {
      var a = Math.random() * Math.PI * 2, sp = 2 + Math.random() * 8;
      parts.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 4 - Math.random() * 3,
        g: .16 + Math.random() * .09, w: 4 + Math.random() * 7, h: 3 + Math.random() * 5,
        rot: Math.random() * 6.28, vr: (Math.random() - .5) * .4, c: FXC[i % FXC.length],
        shape: i % 4, life: 90 + Math.random() * 50, drag: .985 });
    }
    if (!fxRun) fxLoop(cv);
  }
  function fxLoop(cv) {
    fxRun = true;
    var cx = cv.getContext('2d');
    cx.clearRect(0, 0, cv.width, cv.height);
    parts.forEach(function (p) {
      p.vx *= p.drag; p.vy = p.vy * p.drag + p.g; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.life--;
      cx.save(); cx.translate(p.x, p.y); cx.rotate(p.rot);
      cx.globalAlpha = Math.max(0, Math.min(1, p.life / 40)); cx.fillStyle = p.c;
      if (p.shape === 0) cx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      else if (p.shape === 1) { cx.beginPath(); cx.arc(0, 0, p.w / 2, 0, 6.29); cx.fill(); }
      else if (p.shape === 2) { cx.beginPath(); cx.moveTo(0, -p.w / 2); cx.lineTo(p.w / 2, 0); cx.lineTo(0, p.w / 2); cx.lineTo(-p.w / 2, 0); cx.closePath(); cx.fill(); }
      else cx.fillRect(-p.w / 2, -1.2, p.w, 2.4);
      cx.restore();
    });
    parts = parts.filter(function (p) { return p.life > 0 && p.y < cv.height + 30; });
    if (parts.length) requestAnimationFrame(function () { fxLoop(cv); });
    else { fxRun = false; cx.clearRect(0, 0, cv.width, cv.height); }
  }
  function elCenter(el) {
    var inner = document.querySelector('.paintly-cart-page .pc-shell');
    if (!inner || !el) return [200, 140];
    var d = inner.getBoundingClientRect(), r = el.getBoundingClientRect();
    return [r.left - d.left + r.width / 2, r.top - d.top + r.height / 2];
  }
  function megaMoment(anchor, text) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var c = elCenter(anchor);
    blast(c[0], c[1], 130);
    var inner = document.querySelector('.paintly-cart-page .pc-shell');
    if (!inner) return;
    var fo = inner.querySelector('.pc-flashov');
    if (fo && fo.animate) fo.animate([{ opacity: .28 }, { opacity: 0 }], { duration: 520, easing: 'ease-out' });
    var rp = document.createElement('span'); rp.className = 'pc-ripple';
    rp.style.cssText = 'left:' + c[0] + 'px;top:' + c[1] + 'px;width:340px;height:340px';
    inner.appendChild(rp); setTimeout(function () { rp.remove(); }, 950);
    var bb = inner.querySelector('.pc-bigban');
    if (bb) { bb.textContent = text; bb.classList.remove('go'); void bb.offsetWidth; bb.classList.add('go'); }
  }

  /* ── meter ── */
  function renderTrack(s) {
    var t = document.getElementById('pcTrkl'); if (!t) return;
    /* at an exact lap, back up one round (full tube + glowing won gift) until the slide runs */
    var slid = false;
    try {
      var sv = parseInt(sessionStorage.getItem('pc_slid') || '0', 10) || 0;
      if (sv > s.freeCount) { sessionStorage.removeItem('pc_slid'); sv = 0; } /* stale from an earlier, higher round */
      slid = s.freeCount > 0 && sv === s.freeCount;
    } catch (e) {}
    var R = (s.lap && s.freeCount > 0 && !slid) ? s.freeCount - 1 : s.freeCount, h = '';
    for (var j = 0; j < 12; j++) {
      var kitNo = 3 * R + j + 1, x = ((j + 0.5) / 9 * 94).toFixed(3) + '%';
      if ((j + 1) % 3 === 0) {
        var gn = R + (j + 1) / 3;
        h += '<span class="pc-gf" data-kit="' + kitNo + '" style="left:' + x + '">' + GIFT + '<span class="pc-gl2">Free kit ' + gn + '</span></span>';
      } else {
        h += '<span class="pc-mk" data-kit="' + kitNo + '" style="left:' + x + '"><i>' + kitNo + '</i></span>';
      }
    }
    t.innerHTML = h;
    t.querySelectorAll('.pc-mk').forEach(function (mk) {
      if (s.n >= +mk.dataset.kit) { mk.classList.add('on'); mk.innerHTML = CHECK; }
    });
    var nextFound = false;
    t.querySelectorAll('.pc-gf').forEach(function (g) {
      var won = s.n >= +g.dataset.kit;
      g.classList.toggle('won', won);
      if (!won && !nextFound) {
        nextFound = true; g.classList.add('nxt');
        if (s.left === 1 && !s.lap) g.classList.add('near');
      }
    });
    var lf = document.getElementById('pcLfill');
    var prog = Math.max(0, Math.min(3, s.n - 3 * R));
    if (lf) lf.style.width = (prog / 9 * 94) + '%';
  }

  function dealMsg(s) {
    if (s.n === 0) return 'Every 3rd kit is <span class="hl">FREE</span>. Add any 3 kits — the cheapest one costs ' + CUR.sym + '0.';
    if (s.lap) return '<b>You just got free kit ' + s.freeCount + '!</b> Add 3 more kits and free kit ' + (s.freeCount + 1) + ' is yours too — <span class="hl">it never stops</span>.';
    var another = s.freeCount > 0 ? 'another kit is' : 'your 3rd kit is';
    return '<b>' + s.n + ' ' + (s.n === 1 ? 'kit' : 'kits') + ' in your cart</b> — just ' + s.left + ' more and ' + another + ' <span class="hl">FREE</span>.';
  }

  function decorateItems(d, s) {
    d.items.forEach(function (x, li) {
      var row = document.getElementById('CartPageItem-' + x.index);
      if (!row) return;
      row.querySelectorAll('.pc-rowmeta,.pc-giftmsg').forEach(function (n) { n.remove(); });
      /* the craft pill announces PBN/DP — drop the redundant title suffix like
         "(80 Color Paint by Numbers)" / "(150 Color Diamond Painting)" (idempotent) */
      var nameEl = row.querySelector('.cart-item__name');
      if (nameEl) {
        var stripped = nameEl.textContent.trim().replace(/\s*\(([^)]*(paint\s*by\s*numbers|diamond\s*painting|board\s*canvas|pearl\s*painting)[^)]*)\)\s*$/i, '');
        if (stripped && stripped !== nameEl.textContent.trim()) nameEl.textContent = stripped;
      }
      var meta = document.createElement('div');
      meta.className = 'pc-rowmeta';
      var pill;
      if (x.gift) {
        /* a gift card is neither craft — label it as itself, not "Paint by Numbers" */
        pill = '<span class="pc-craft gift">' + GIFT + 'Gift card</span>';
      } else if (/pearl[\s-]*painting/i.test(x.title + ' ' + x.handle)) {
        /* a pearl painting is its own craft (26 Oct 2026) */
        pill = '<span class="pc-craft pearl">' + PEARL + 'Pearl Painting</span>';
      } else {
        var isDP = /diamond/i.test(x.title + ' ' + x.handle);
        /* carry the color count into the pill (the title suffix it came from is stripped) */
        var cm = String(x.title).match(/(\d+)\s*colors?\b/i);
        var craftLabel = (cm ? cm[1] + ' Color ' : '') + (isDP ? 'Diamond Painting' : 'Paint by Numbers');
        pill = '<span class="pc-craft ' + (isDP ? 'dp' : 'pbn') + '">' + (isDP ? GEM : PALETTE) + craftLabel + '</span>';
      }
      var photo = '';   /* 8 Oct 2026: no photo chip; the kit's own picture shows instead */
      if (x.gift) {
        photo = '';
        if (x.gift_to) photo += '<span class="pc-photochip pc-giftto">' + CHECK + 'To ' + String(x.gift_to).replace(/[<>&"]/g, '') + '</span>';
        var gd = giftDate(x.gift_date);
        if (gd) photo += '<span class="pc-photochip pc-giftdate">' + CAL + 'Sends ' + gd + '</span>';
      }
      var chip = '';
      var orig = x.price * x.qty, priceHtml = money(orig);
      if (s.code) {
        if (x.line_discount > 0) {
          /* this line's own saving, not the order-wide figure — a code can apply to some lines only */
          var lpct = orig > 0 ? Math.round(x.line_discount / orig * 100) : 0;
          var lbl = (s.code.vt === 'fixed_amount' || lpct <= 0) ? money(x.line_discount) : lpct + '%';
          chip = '<span class="pc-freechip">-' + lbl + '</span>';
          priceHtml = '<s>' + money(orig) + '</s>' + money(orig - x.line_discount);
        }
      } else if (s.realDeal) {
        if (x.line_discount > 0) {
          var fuR = Math.min(x.qty, Math.round(x.line_discount / x.price));
          chip = '<span class="pc-freechip">' + (fuR === x.qty ? 'FREE' : fuR + ' FREE') + '</span>';
          priceHtml = '<s>' + money(orig) + '</s>' + money(orig - x.line_discount);
        }
      } else {
        var fu = s.freeBy[li] || 0;
        if (fu > 0) {
          chip = '<span class="pc-freechip">' + (fu === x.qty ? 'FREE' : fu + ' FREE') + '</span>';
          priceHtml = '<s>' + money(orig) + '</s>' + money(x.price * (x.qty - fu));
        }
      }
      meta.innerHTML = pill + photo + chip;
      var host = row.querySelector('.cart-item__details') || row.querySelector('[class*="details"]') || row;
      host.appendChild(meta);
      if (x.gift && String(x.gift_msg || '').trim()) {
        var gm = document.createElement('div');
        gm.className = 'pc-giftmsg';
        gm.textContent = '\u201C' + String(x.gift_msg).trim() + '\u201D';
        host.appendChild(gm);
      }
    });
  }

  function pcSlide(fc) {
    var t = document.getElementById('pcTrkl'); if (!t) return;
    var d2 = readData(); if (!d2) return;
    var s2 = computeState(d2);
    if (!s2.lap || s2.freeCount !== fc || s2.code) return;   /* cart changed meanwhile */
    try { if (sessionStorage.getItem('pc_slid') === String(fc)) return; } catch (e) {} /* already slid this round */
    /* panel collapsed on mobile → no visual stage; just commit the state */
    if (document.documentElement.classList.contains('pc-folded') && window.matchMedia('(max-width: 480px)').matches) {
      try { sessionStorage.setItem('pc_slid', String(fc)); } catch (e) {}
      render();
      return;
    }
    if (pcMo) pcMo.disconnect();
    var lw = document.getElementById('pcLanewrap');
    if (lw) lw.classList.add('sliding'); /* clip hard at the lane's left edge while markers travel */
    t.style.transition = 'transform .65s cubic-bezier(.35,.8,.3,1)';
    t.style.transform = 'translateX(-31.333%)';
    var lf = document.getElementById('pcLfill'); if (lf) lf.style.width = '0%';
    var doneRan = false;
    var done = function () {
      if (doneRan) return; doneRan = true;
      t.removeEventListener('transitionend', done);
      try { sessionStorage.setItem('pc_slid', String(fc)); } catch (e) {}
      t.style.transition = 'none';
      t.style.transform = '';
      render();
      if (lw) lw.classList.remove('sliding');
      setTimeout(function () { t.style.transition = ''; }, 60);
    };
    t.addEventListener('transitionend', done);
    setTimeout(done, 1100); /* fallback if transitionend never fires (tab hidden, element replaced) */
    setTimeout(function () { pcObserve(); }, 800);
  }
  function pcCloseIcon() {
    var xb = document.querySelector('.cart-drawer .drawer__header .drawer__close');
    if (xb && !xb.dataset.pc) {
      xb.dataset.pc = '1';
      xb.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>';
    }
  }
  var pcMo = null;
  function pcObserve() {
    var drawer = document.getElementById('PaintlyCartPage');
    if (drawer && pcMo) pcMo.observe(drawer, { childList: true, subtree: true });
  }
  /* Roadmap 7a. Keep the minus glyph honest: at quantity 1 the button removes the
     line rather than decreasing it, so it shows a bin. The server renders the first
     state; this keeps it right afterwards. Called from renderInner, which the drawer's
     MutationObserver already runs on every re-render, and again straight after a tap so
     the glyph flips immediately rather than waiting for the cart round trip. */
  function syncMinus() {
    var rows = document.querySelectorAll('.pc-item');
    for (var i = 0; i < rows.length; i++) {
      var inp = rows[i].querySelector('.quantity__input');
      var btn = rows[i].querySelector('.quantity__button--minus');
      if (!inp || !btn) continue;
      var one = (parseInt(inp.value, 10) || 1) <= 1;
      btn.classList.toggle('pc-willremove', one);
    }
  }

  function render() {
    if (pcMo) pcMo.disconnect();
    try { renderInner(); } finally { pcObserve(); }
  }
  function renderInner() {
    pcCloseIcon();
    syncMinus();
    var eb = document.querySelector('.pc-empty .button');
    if (eb && !eb.dataset.pc) {
      eb.dataset.pc = '1';
      eb.insertAdjacentHTML('beforeend', '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h15M13 6l6 6-6 6"/></svg>');
    }
    var d = readData(); if (!d) return;
    if (d.cur && d.cur.iso) CUR = d.cur;
    var s = computeState(d);
    var panel = document.getElementById('pcPanel'); if (!panel) return;
    panel.classList.toggle('codeon', !!s.code);
    /* collapsed state lives on <html>; default = collapsed on mobile when the cart has items
       (empty drawer keeps the panel open — it's the hook there). Manual choice wins for the session. */
    var pcStored = null; try { pcStored = sessionStorage.getItem('pc_fold'); } catch (eF) {}
    var pcFolded = pcStored === null
      ? (window.matchMedia('(max-width: 480px)').matches && s.n > 0)
      : pcStored === '1';
    document.documentElement.classList.toggle('pc-folded', pcFolded); var foldControl=document.getElementById('pcFold'); if(foldControl) foldControl.setAttribute('aria-expanded', pcFolded ? 'false' : 'true');
    /* header count */
    var hc = document.getElementById('pcCount') || null;
    /* pill */
    var pill = document.getElementById('pcPill');
    if (pill) {
      if (s.freeCount > 0) { pill.className = 'pc-pill'; pill.textContent = s.freeCount + ' FREE · -' + money(s.save); }
      else if (pcFolded) { pill.className = 'pc-pill'; pill.textContent = 'VIEW OFFERS'; }
      else { pill.className = 'pc-pill zero'; pill.textContent = 'NO LIMIT'; }
    }
    var msg = document.getElementById('pcMsg');
    if (msg) {
      msg.innerHTML = dealMsg(s);
      /* on mobile only actionable moments keep the message line (CSS hides the rest):
         empty-cart teaser, 1 kit away, or a just-completed round */
      msg.classList.toggle('key', s.n === 0 || s.n % 3 === 2 || (s.lap && s.freeCount > 0));
    }
    /* panel internals stay hidden (CSS :not(.pc-ready)) until this render pass fills them */
    panel.classList.add('pc-ready');
    /* short placeholder on narrow screens so it never clips behind Apply */
    var ci = document.getElementById('pcCcIn');
    if (ci && ci.placeholder.indexOf('already used') === -1) ci.placeholder = window.matchMedia('(max-width: 480px)').matches ? 'Discount code' : 'Have a discount code? Enter it here';
    renderTrack(s);
    /* code ticket */
    var cc = document.getElementById('pcCodecard');
    if (cc) {
      cc.classList.toggle('on', !!s.code);
      if (s.code) {
        var cn = document.getElementById('pcCcName');
        cn.textContent = s.code.label;
        var L = s.code.label.length;
        cn.style.fontSize = L > 12 ? '13px' : (L > 9 ? '15px' : '19px');
        /* whole sub-line is rewritten: a shipping-only or zero-value code must not
           read "0% off your whole order" */
        var cs = document.getElementById('pcCcSub');
        if (cs) {
          cs.innerHTML = s.code.txt
            ? '<b id="pcCcPct">' + s.code.txt + '</b> your whole order &middot; code applied'
            : '<b id="pcCcPct">Code applied</b>';
        }
        document.getElementById('pcCnote').innerHTML = s.codeOff > 0
          ? "You're saving <b>" + money(s.codeOff) + '</b> on this order' + (s.shipDone ? ', and shipping is free' : '') + '.'
          : 'Your code is on this order' + (s.shipDone ? ', and shipping is free' : '') + '.';
      }
    }
    /* shipping lane */
    var ship = document.getElementById('pcShip');
    if (ship) {
      /* A gift card is delivered by email, so a gift-card-only cart ships nothing.
         "$10 to free shipping" would be a promise about a parcel that never exists. */
      var noShip = d.requires_shipping === false && d.items && d.items.length > 0;
      ship.style.display = noShip ? 'none' : '';
      if (!noShip) {
        ship.classList.toggle('done', s.shipDone);
        document.getElementById('pcRoadfill').style.width = s.shipPct + '%';
        /* park the truck just short of the finish flag (flag owns the last ~28px) */
        document.getElementById('pcTrk').style.left = 'min(' + Math.min(s.shipPct, 97) + '%, 100% - 28px)';
        document.getElementById('pcHlb').innerHTML = s.shipDone ? 'Free shipping<b>UNLOCKED</b>' : 'to free shipping<b>' + money(s.shipLeft) + '</b>';
      }
    }
    /* footer */
    var cf = document.getElementById('pcCodefield');
    if (cf) cf.classList.toggle('codeon', !!s.code);
    var sub = document.getElementById('pcSub'); if (sub) sub.textContent = money(s.sub);
    var sr = document.getElementById('pcSaveRow');
    if (sr) {
      sr.style.display = s.save > 0 ? 'flex' : 'none';
      if (s.save > 0) {
        document.getElementById('pcSaveLbl').textContent = 'Every 3rd kit free (' + s.freeCount + ' free ' + (s.freeCount === 1 ? 'kit' : 'kits') + ')';
        document.getElementById('pcSaveAmt').textContent = '-' + money(s.save);
      }
    }
    var cr = document.getElementById('pcCodeRow');
    if (cr) {
      cr.style.display = s.codeOff > 0 ? 'flex' : 'none';
      if (s.codeOff > 0) {
        document.getElementById('pcCodeLbl').textContent = 'Code ' + s.code.label;
        document.getElementById('pcCodeAmt').textContent = '-' + money(s.codeOff);
      }
    }
    var sc = document.getElementById('pcSavecard');
    if (sc) {
      var totSave = s.save + s.codeOff;
      sc.classList.toggle('on', totSave > 0);
      if (totSave > 0) {
        var partsTxt = [];
        if (s.freeCount > 0) partsTxt.push(s.freeCount + ' free ' + (s.freeCount === 1 ? 'kit' : 'kits'));
        if (s.code) partsTxt.push('code ' + s.code.label + (s.code.txt ? ' (' + s.code.txt + ')' : ''));
        if (s.shipDone) partsTxt.push('free shipping');
        document.getElementById('pcScSub').textContent = partsTxt.join(' · ');
        document.getElementById('pcScWas').textContent = 'was ' + money(s.sub);
        document.getElementById('pcScAmt').textContent = '-' + money(totSave);
      }
    }
    var tot = document.getElementById('pcTot'); if (tot) tot.textContent = money(s.tot) + ' ' + CUR.iso;
    decorateItems(d, s);
    /* unlock spectacle: compare stored freeCount */
    try {
      var prev = +(sessionStorage.getItem('pc_prev_free') || 0);
      if (s.freeCount > prev && !s.code) {
        var g = document.querySelector('#pcTrkl .pc-gf.won') || document.querySelector('#pcTrkl .pc-gf') || panel;
        /* collapsed on mobile → the gift markers are display:none; anchor the celebration to the panel */
        if (document.documentElement.classList.contains('pc-folded') && window.matchMedia('(max-width: 480px)').matches) g = panel;
        setTimeout(function () { megaMoment(g, 'FREE KIT ' + s.freeCount + ' UNLOCKED'); }, 250);
        setTimeout(function () { pcSlide(s.freeCount); }, 1500);
      }
      sessionStorage.setItem('pc_prev_free', String(s.freeCount));
    } catch (e) {}
  }

  function wire() {
    /* ?pcdebug=1 → tiny on-screen diagnostics badge (scale, widths, input font, media flags) */
    if (/pcdebug/.test(location.search)) {
      var dbg = document.createElement('div');
      dbg.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:2147483647;background:#000;color:#7CFC00;font:11px/1.5 monospace;padding:6px 9px;border-radius:8px;opacity:.92;pointer-events:none;max-width:90vw';
      document.body.appendChild(dbg);
      var upd = function () {
        var inp = document.getElementById('pcCcIn');
        var vv = window.visualViewport;
        dbg.textContent = 'scale:' + (vv ? vv.scale.toFixed(2) : '?')
          + ' iw:' + window.innerWidth + ' sw:' + document.documentElement.scrollWidth
          + ' fs:' + (inp ? getComputedStyle(inp).fontSize : '-')
          + ' coarse:' + (matchMedia('(pointer: coarse)').matches ? 1 : 0)
          + ' hovNone:' + (matchMedia('(hover: none)').matches ? 1 : 0)
          + ' foc:' + (document.activeElement && document.activeElement.id === 'pcCcIn' ? 1 : 0);
      };
      setInterval(upd, 400); upd();
    }
    /* iOS focus-zoom killer: Safari only auto-zooms on NATIVE tap-focus. Intercept the
       tap on the code field and focus it programmatically — keyboard still opens
       (same user gesture), zoom never fires. */
    document.addEventListener('touchend', function (e) {
      var inp = e.target.closest && e.target.closest('#pcCcIn');
      if (!inp || document.activeElement === inp) return;
      e.preventDefault();
      inp.focus();
    }, { passive: false });
    /* mobile chevron: collapse/expand the offer panel, remembered for the session.
       When folded, the whole title row is a tap target. */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var f = e.target.closest('#pcFold');
      var row = !f && document.documentElement.classList.contains('pc-folded') && e.target.closest('#pcPanel .pc-a1');
      if (!f && !row) return;
      var now = !document.documentElement.classList.contains('pc-folded');
      document.documentElement.classList.toggle('pc-folded', now);
      try { sessionStorage.setItem('pc_fold', now ? '1' : '0'); } catch (err) {}
      var fb = document.getElementById('pcFold'); if (fb) fb.setAttribute('aria-expanded', now ? 'false' : 'true');
      render(); /* pill copy depends on fold state (VIEW OFFERS ↔ NO LIMIT) */
    });
    document.addEventListener('input', function (e) {
      if (e.target && e.target.id === 'pcCcIn') {
        var cf = document.getElementById('pcCodefield');
        if (cf) cf.classList.toggle('hasval', !!e.target.value.trim());
      }
    });
    document.addEventListener('click',function(e){
      if(!e.target.closest) return;
      var root=e.target.closest('#PaintlyCartPage'); if(!root) return;
      var step=e.target.closest('[data-quantity-step]');
      if(step){
        e.preventDefault();
        var row=step.closest('.pc-item');var n=Number(row.dataset.quantity)+Number(step.dataset.quantityStep);
        changeCart('change',{id:row.dataset.key,quantity:Math.max(0,n)},false);
      }
      if(e.target.closest('#pcCcApply')){
        var input=document.getElementById('pcCcIn');var code=(input.value||'').replace(/\s+/g,'').toUpperCase();
        if(!code || pageBusy) return;
        changeCart('update',{discount:code},true).then(function(cart){
          if(!cart) return;
          var accepted=(cart.discount_codes||[]).some(function(c){return c.code && c.code.toUpperCase()===code && c.applicable;});
          if(accepted) megaMoment(document.getElementById('pcCodecard'),'CODE '+code+' APPLIED');
          else {
            var keep=(cart.discount_codes||[]).filter(function(c){return c.applicable && c.code.toUpperCase()!==code;}).map(function(c){return c.code;}).join(',');
            changeCart('update',{discount:keep},true).then(function(){pageMessage(root.dataset.codeError,true);});
          }
        });
      }
      if(e.target.closest('#pcRmCode')) changeCart('update',{discount:''},true);
    });
    document.addEventListener('change',function(e){
      if(!e.target.closest || !e.target.closest('#PaintlyCartPage')) return;
      if(e.target.name==='updates[]'){
        var row=e.target.closest('.pc-item'),n=Number(e.target.value);
        if(e.target.value.trim()===''||!Number.isInteger(n)||n<0){e.target.value=row.dataset.quantity;return;}
        changeCart('change',{id:row.dataset.key,quantity:n},false);
      }
      if(e.target.id==='PaintlyCartNote') changeCart('update',{note:e.target.value},false);
    });
    document.addEventListener('keydown',function(e){
      if(e.target.id==='pcCcIn' && e.key==='Enter'){e.preventDefault();document.getElementById('pcCcApply').click();}
    });
    document.addEventListener('submit',function(e){
      if(e.target.id==='PaintlyCartPageForm' && (pageBusy || pageUncertain)){e.preventDefault();return;}
      if(e.target.id==='PaintlyCartPageForm' && e.submitter && e.submitter.name==='checkout'){
        e.preventDefault();checkoutCart();return;
      }
      if(e.target.id==='PaintlyCartPageForm' && (!e.submitter || e.submitter.name!=='checkout')){
        e.preventDefault();var updates={};e.target.querySelectorAll('.pc-item').forEach(function(row){updates[row.dataset.key]=Math.max(0,Number(row.querySelector('[name="updates[]"]').value)||0);});
        changeCart('update',{updates:updates},false);
      }
    });
    var drawerHost=document.querySelector('cart-drawer');
    drawerSeen=cartSignature('pkCartData');
    if(drawerHost) new MutationObserver(function(){
      var current=cartSignature('pkCartData');
      if(!current || current===drawerSeen) return;
      drawerSeen=current;
      drawerSyncPending=true;
      scheduleDrawerSync();
    }).observe(drawerHost,{childList:true,subtree:true});

    /* re-render (debounced) whenever Shrine swaps any part of the drawer;
       render() disconnects the observer while it mutates, so no self-loops */
    var moT;
    pcMo = new MutationObserver(function () {
      clearTimeout(moT);
      moT = setTimeout(render, 120);
    });
    pcObserve();
    window.addEventListener('resize', function () { fxCanvas(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wire(); render(); });
  } else { wire(); render(); }
})();
